import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CompareViewer from "./CompareViewer.js"; // new component for /:folderId
import Editor from "./Editor"; // your full UI

function App() {
  // const baseURL = "http://localhost:9000"
  const baseURL = "https://slider.vividlybuilt.com"
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Editor baseURL={baseURL} />} />
        <Route path="/:folderId" element={<CompareViewer baseURL={baseURL}/>} />
      </Routes>
    </Router>
  );
}
export default App;
